<template>
  <div class="login">
    <AppBox class="box">
      <div class="bigTitle">树智银境教务管理系统</div>
      <!--      <img-->
      <!--        @click="handleToWeChat"-->
      <!--        class="code"-->
      <!--        src="../../assets/png/click_code.png"-->
      <!--      />-->
      <div v-if="isLogin">
        <TabsChange :tabList="tabList">
          <template v-slot:0>
            <div class="contentBox">
              <el-form
                  ref="form1"
                  :rules="form1Rules"
                  :model="form1"
                  size="small"
              >
                <el-form-item prop="phone">
                  <el-input
                      style="width: 300px"
                      v-model="form1.phone"
                      placeholder="手机号码"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                      style="width: 300px"
                      placeholder="密码"
                      v-model="form1.password"
                      show-password
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                      style="width: 300px"
                      class="loginBtn"
                      type="primary"
                      @click="handleLoginOnWord"
                  >登录
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                      style="width: 300px"
                      @click="tenantRegisterHandle"
                  >企业注册
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </template>
          <template v-slot:1>
            <div class="contentBox">
              <el-form
                  ref="form2"
                  :rules="form2Rules"
                  :model="form2"
                  size="small"
              >
                <el-form-item prop="phone">
                  <el-input
                      style="width: 300px"
                      placeholder="手机号码"
                      v-model="form2.phone"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="captcha">
                  <el-input
                      style="width: 160px"
                      v-model="form2.captcha"
                      placeholder="请输入验证码"
                  ></el-input>
                  <el-button
                      style="
                      display: inline-block;
                      width: 130px;
                      margin-left: 10px;
                    "
                      @click="getCaptcha"
                      :disabled="countingDown"
                      size="small"
                      :type="countingDown ? '' : 'primary'"
                  >{{ countingDown ? `重新获取(${counter})s` : "获取验证码" }}
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                      style="width: 300px"
                      class="loginBtn"
                      type="primary"
                      @click="handleLoginOnCode"
                  >登录
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </TabsChange>
        <!--        <div class="titleBox">-->
        <!--          <div @click="handleToRegister">没有账号？<span>点此注册</span></div>-->
        <!--        </div>-->
        <div class="alternate-login">
          <span>其他方式登录</span>
          <img
              class="weiXin"
              @click="handleToWeChat"
              src="../../assets/png/weiXin.png"
              alt=""
          />
        </div>
      </div>
      <div v-else>
        <div class="contentBox">
          <el-form
              ref="form2"
              :rules="rules"
              :model="formData"
              size="small"
              label-position="right"
          >
            <el-form-item prop="phone">
              <el-input
                  style="width: 300px"
                  v-model="formData.phone"
                  placeholder="手机号码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input
                  style="width: 160px"
                  v-model="formData.captcha"
                  placeholder="请输入验证码"
              ></el-input>
              <el-button
                  style="display: inline-block; width: 130px; margin-left: 10px"
                  @click="getCaptcha"
                  :disabled="countingDown"
                  size="small"
                  :type="countingDown ? '' : 'primary'"
              >{{ countingDown ? `重新获取(${counter})s` : "获取验证码" }}
              </el-button>
            </el-form-item>
            <el-form-item prop="passwordOnce">
              <el-input
                  style="width: 300px"
                  placeholder="密码"
                  v-model="formData.passwordOnce"
                  show-password
              ></el-input>
            </el-form-item>
            <el-form-item prop="passwordTwice">
              <el-input
                  style="width: 300px"
                  placeholder="确认密码"
                  v-model="formData.passwordTwice"
                  show-password
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formData.checked"
              ><span class="readBox">我已阅读并同意</span
              ><span class="agreeBox">注册协议</span></el-checkbox
              >
              <el-button
                  style="width: 300px"
                  class="loginBtn"
                  type="primary"
                  @click="handleRegister"
              >注册并登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="titleBox">
          <div @click="handleToRegister">已有帐号？<span>点此登录</span></div>
        </div>
      </div>
    </AppBox>
    <institution-modal/>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import TabsChange from "@/components/TabsChange/index.vue";
import {loginMixin} from "@/mixins/loginMixins";
import InstitutionModal from "@/pages/Login/institutionModal.vue";
import {mapActions} from "vuex";

export default {
  name: "Login",
  components: {InstitutionModal, TabsChange, AppBox},
  mixins: [loginMixin],
  data() {
    return {
      isCode: false,
      isLogin: true,
      tabList: ["密码登录", "验证码登录"],
    };
  },
  methods: {
    ...mapActions("user", ["getAuthorize"]),
    //切换登录注册
    handleToRegister() {
      this.isLogin = !this.isLogin;
      // this.clearForm()
    },
    //第三方登录,重定向到微信扫码页面
    async handleToWeChat() {
      const res = await this.getAuthorize();
      // console.log(res, "5555555555555555555555");
      // this.$router.push(
      //   {
      //     name: "AccountBinding",
      //   },
      //   () => {}
      // );
      window.location.href = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.login {
  height: 100vh;
  background: map-get($colors, primary);
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    width: 400px;
    background: #ffffff;
    padding: 20px;
    position: relative;

    .bigTitle {
      //text-align: center;
      color: map-get($colors, primary);
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 30px;
    }

    .code {
      position: absolute;
      width: 50px;
      right: 20px;
      z-index: 0;
      cursor: pointer;
    }

    .code:hover {
      transform: translateY(-10%) translateX(10%) scale(1.5);
    }

    .contentBox {
      text-align: center;
      padding: 10px 0 0 0;

      .readBox {
        color: #606266;
      }

      .agreeBox {
        color: map-get($colors, primary);
      }

      .loginBtn {
        width: 100%;
        margin: 20px 0 0 0;
      }
    }

    .titleBox {
      margin-bottom: 10px;

      div {
        font-size: 12px;
        text-align: center;

        span {
          cursor: pointer;
          color: map-get($colors, primary);
          z-index: 9999;
        }
      }
    }

    .alternate-login {
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        position: relative;
        font-size: 13px;
        text-transform: uppercase;
        color: #ccc;
        margin-bottom: 20px;
      }

      span::before,
      span::after {
        content: "";
        position: absolute;
        top: 50%;
        width: 100%;
        height: 1px;
        background-color: #ccc;
      }

      span::before {
        right: 100%;
        margin-right: 10px;
      }

      span::after {
        left: 100%;
        margin-left: 10px;
      }

      .weiXin {
        width: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
